
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/en/faq",
      function () {
        return require("private-next-pages/nl/en/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/en/faq"])
      });
    }
  